import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      setError(true);
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/google/session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        applyAuth(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        setError(true);
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-[#090A0F] grid-bg flex items-center justify-center px-4">
      <div className="text-center">
        {error ? (
          <>
            <XCircle className="w-10 h-10 text-rose-400 mx-auto" />
            <p className="text-slate-300 mt-4">Anmeldung fehlgeschlagen.</p>
            <button
              onClick={() => navigate("/login")}
              className="mt-6 bg-white/10 hover:bg-white/15 border border-white/10 text-white font-medium rounded-full px-6 py-2.5 transition-all"
            >
              Zurück zum Login
            </button>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 text-fuchsia-400 mx-auto animate-spin" />
            <p className="text-slate-400 mt-4">Anmeldung läuft...</p>
          </>
        )}
      </div>
    </div>
  );
}
